import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {Link, useParams} from "react-router-dom";
import { Button } from "react-bootstrap";
import { getAllForIndividualsCommentsView, getAllForIndividualsParaView, getAllForIndividualsStepView } from "../../api/axios";
// const id = 1;
function ForIndividuals() {
    const { partnerId } = useParams();
    const [paraViewId, setParaViewId] = useState(null);
    const [stepView, setStepView] = useState(null);
    const [commentsView, setCommentsView] = useState(null);
    

    useEffect(() => {
      if (!Number(partnerId)) return;
      fetchParaViewData();
      fetchStepViewData();
      fetchCommentsViewData();
    }, [partnerId]);

    const fetchParaViewData = async () => {
      try {
        const response = await getAllForIndividualsParaView(partnerId);
        console.log(response.data.data[0]);
        if (response.data.data.length > 0) {
          setParaViewId(response.data.data[0].paragraph_id);
        } else {
          console.log(response.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const fetchStepViewData = async () => {
      try {
        const response = await getAllForIndividualsStepView(partnerId);
        console.log(response.data.data[0]);
        if (response.data.data.length > 0) {
          setStepView(response.data.data[0].step_id);
          console.log(response.data.data[0].step_id);
        } else {
          console.log(response.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const fetchCommentsViewData = async () => {
      try {
        const response = await getAllForIndividualsCommentsView(partnerId);
        console.log('getAllForIndividualsCommentsView', response.data.data[0]);
        if (response.data.data.length > 0) {
          setCommentsView(response.data.data[0].comment_id);
          console.log(response.data.data[0].comment_id);
        } else {
          console.log(response.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    };

    return (
    <ContentWrapper>
      <Title>Select a section</Title>
      <SectionWrapper>
    
        
        <Link to={`/${partnerId}/forindividuals/para/view/${Number(paraViewId) ? paraViewId : 'create' }`}>
          <Button className="mb-0">Header Section</Button>
        </Link> 
        <Link to={`/${partnerId}/forindividuals/step/view/${Number(stepView) ? stepView : 'create' }`}>
        <Button className="mb-0">Step Cards Section</Button>
        </Link>
        <Link to={`/${partnerId}/forindividuals/comments/view/${Number(commentsView) ? commentsView : 'create' }`}>
        <Button className="mb-0">Comments Section</Button>
        </Link>
        
      </SectionWrapper>
    </ContentWrapper>
  );
}

export default ForIndividuals;
const ContentWrapper = styled.div`
   @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
 @media (min-width:576px) {
   margin-bottom: .5rem;
  }
   @media (min-width:768px) {
    margin-bottom: 1rem;
  }
   margin-bottom: .25rem;
`;

const SectionWrapper = styled.div`
  /* justify-content: center;
  align-items: center;
  gap: 12px; */
  display: flex;
  gap: 6rem;
  justify-content: center;
  // padding-top: 5rem;
   @media (max-width:1400px) {
    gap: 2rem !important;
   }
     @media (max-width:1200px) {
    gap: 1rem !important;
   }
      @media (max-width:694px) {
   flex-wrap: wrap;
   }
     @media (max-width:369px) {
   flex-direction:column;
   gap: 0.5rem !important;
   }
`;
